// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1zGVy","approved":"Status_approved__12qMj","rejected":"Status_rejected__2p_Bw","expired":"Status_expired__1dARh","label":"Status_label__5Qi4j"};